module.exports = __webpack_public_path__ + "static/order-banner-high-res-7e66f328f04bf1ad8aea8c599cc9d06a.jpg";